module.exports = __webpack_public_path__ + "static/media/Bil-min.69727edb.PNG";